import { render, staticRenderFns } from "./perfiles-cargo-editar.vue?vue&type=template&id=730ec47e&scoped=true&"
import script from "./perfiles-cargo-editar.vue?vue&type=script&lang=js&"
export * from "./perfiles-cargo-editar.vue?vue&type=script&lang=js&"
import style0 from "./perfiles-cargo-editar.vue?vue&type=style&index=0&id=730ec47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ec47e",
  null
  
)

export default component.exports